import React, { useState } from "react"
import { Backdrop, CircularProgress, Typography } from "@mui/material"

import { Navigate, Route, Routes } from "react-router-dom"
import Suscribers from "./Suscribers/Suscribers"
import useStyleOrganization from "./useStyleOrganizations"
import OrganizationTable from "./TableNavigable/TableNavigable"
// import addIcon from '../../images/addIcon.png'
// import StepperAddOrganization from '../../components/Modals/Organizations/RightModals/createNewOrganization'
import { ButtonSearchModal } from "../../components/Modals/Organizations/ModalSearchCUIT"
import Users from "./Users/Users"
import { SuborganizationsOfOrganizations } from "./Suborganizations/SuborganizationsOfOrganizations"

import InfoIcon from "@mui/icons-material/Info"

export default function Organizations() {
  return (
    <Routes>
      <Route path="/" element={<Organization />} />
      <Route path=":id/subscribers" element={<Suscribers />} />
      <Route path=":id/users" element={<Users />} />
      <Route
        path=":id/suborganizations"
        element={<SuborganizationsOfOrganizations />}
      />

      <Route path="*" element={<Navigate replace to="/home" />} />
    </Routes>
  )
}

function Organization() {
  const classes = useStyleOrganization()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  // const [stateAddOrganization, setstateAddOrganization] = useState(false)
  const [openFilterByType, setopenFilterByType] = useState(false)
  const [valueFilter, setvalueFilter] = useState(null)

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Organizaciones</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá buscar y/o gestionar las organizaciones de
          Errepar+. La siguiente lista muestra las organizaciones de tipo
          testeo. Si desea buscar una organización por CUIT seleccione la opción
          Buscar por CUIT o por Nombre y/o Nombre legal utilice la barra de
          busqueda.
        </Typography>
      </div>
      <div className={classes.containerBody}>
        <div className={classes.boxButtons}>
          <ButtonSearchModal
            setLoading={setLoading}
            setRows={setRows}
            setopenFilterByType={setopenFilterByType}
            setvalueFilter={setvalueFilter}
          />
        </div>

        <div className={classes.boxTable}>
          <OrganizationTable
            rows={rows}
            setRows={setRows}
            loading={loading}
            setLoading={setLoading}
            openFilterByType={openFilterByType}
            setopenFilterByType={setopenFilterByType}
            valueFilter={valueFilter}
            setvalueFilter={setvalueFilter}
          />
        </div>
      </div>
    </div>
  )
}
